// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Messages-styles-__text-unknown-button__wrapper--9ejG8","button":"src-components-Messages-styles-__text-unknown-button__button--2qqt8","label":"src-components-Messages-styles-__text-unknown-button__label--2VcMj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/text-unknown-button.css
// module id = 1972
// module chunks = 0